/* Ott-common */
import { normalize } from '@dtvgo/typed-normalizr';
import { AuthType } from '@dtvgo/axios-interceptor-auth';

/* Utils */
import { BlimStationEntity, PROVIDER } from '../../../utils';

/**
 * @param {import('axios').AxiosInstance} backendAxiosInstance
 */
export default function epg(backendAxiosInstance) {
  async function getStations() {
    const response = await backendAxiosInstance.get('/blim/content/v1/epg/channels', {
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize({
      ...(response.data?.map(({
        id,
        channelNumber,
        images,
        ...item
      }) => ({
        stationId: id,
        id: channelNumber,
        channelNumber,
        pictures: images,
        sourceProvider: PROVIDER.BLIM,
        ...item,
      }))),
    }, [BlimStationEntity]);

    return response;
  }

  async function getSchedules({
    fromDatetime,
    toDatetime,
    channelNumbers,
    PageNumber = 0,
    PageSize = 3,
  }) {
    const response = await backendAxiosInstance.get('/blim/content/v1/epg/schedule', {
      params: {
        startTime: fromDatetime,
        endTime: toDatetime,
        channelNumber: channelNumbers?.join(','),
        PageNumber,
        PageSize,
      },
      authType: AuthType.SESSION_TOKEN,
    });

    const modifiedData = response.data?.map((station) => ({
      id: station.channelNumber,
      sourceProvider: PROVIDER.BLIM,
      ...station,
    }));

    response.normalizedData = normalize(modifiedData, [BlimStationEntity]);

    return response;
  }

  return {
    getStations,
    getSchedules,
  };
}
